module.exports = __webpack_public_path__ + "e-learning-app/static/img/school2.3972e17.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/ne/school2.png
// module id = X77N
// module chunks = 1